var YepNopeMessagePopup = require("app/AppLayout/YepNopeMessagePopup"),
    frameThrottle       = require("enyo-perf/utils").frameThrottle,
    icons               = require("app/theme/icons"),
    kind                = require("enyo/kind");

module.exports = kind(/** @lends  app.ProfilePage.RemoveAccountVerificationMessage.prototype */ {

    /**
     * @private
     */
    name: "app.ProfilePage.RemoveAccountVerificationMessage",

    /**
     * @private
     */
    kind: YepNopeMessagePopup,

    /**
     * @private
     */
    classes: "app-profile-page-remove-account-verification-message",

    /**
     * @private
     */
    handlers: {
        onMessageYepButtonTap:  "onMessageYepButtonTap",
        onMessageNopeButtonTap: "onMessageNopeButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.yepButton.set("icon", icons["app.ProfilePage.RemoveAccountVerificationMessage.yepButton"]);
            this.$.message.$.nopeButton.set("icon", icons["app.ProfilePage.RemoveAccountVerificationMessage.nopeButton"]);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.ProfilePage.RemoveAccount.VerificationMessage.title"));
        $message.$.body.set("content", i18nService.getString("app.ProfilePage.RemoveAccount.VerificationMessage.body"));
        $message.$.yepButton.set("caption", i18nService.getString("app.ProfilePage.RemoveAccount.VerificationMessage.OkButton.caption"));
        $message.$.yepButton.set("tooltip", i18nService.getString("app.ProfilePage.RemoveAccount.VerificationMessage.OkButton.tooltip"));
        $message.$.nopeButton.set("caption", i18nService.getString("app.ProfilePage.RemoveAccount.VerificationMessage.CancelButton.caption"));
        $message.$.nopeButton.set("tooltip", i18nService.getString("app.ProfilePage.RemoveAccount.VerificationMessage.CancelButton.tooltip"));
    },

    /**
     * Also close the popup. This event will continue to bubble and the
     * resubscribe button will do the actual resubscribing.
     *
     * @private
     */
    onMessageYepButtonTap: function() {
        this.close();
    },

    /**
     * Close the popup
     *
     * @private
     */
    onMessageNopeButtonTap: function() {
        this.close();
    }

});
